module.exports = __webpack_public_path__ + "static/media/hitachi_logo_white.4ac8fa78.svg";